// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"fe619c1a","333":"c6c06723","377":"011f3ad7","401":"61c33f81","601":"5df45323","617":"c6c976a8","680":"45919bc3","815":"a9a3acbf","835":"13c0043a","857":"5bdc59a3","916":"f1406c04"}[chunkId] + ".chunk.js";
};